import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'matrix' | 'golden-bull' | 'cyber-purple' | 'ice';

interface ThemeState {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'golden-bull',
      setTheme: (theme: Theme) => set({ theme }),
    }),
    {
      name: 'theme-storage',
    }
  )
);
